export interface DisplayedColumnsActiveViewSyncState {
  activeViewStorageKey: string | null;
  initializedFromStorage: boolean;
}

export function shouldSkipDisplayedColumnsActiveViewSync(
  state: DisplayedColumnsActiveViewSyncState,
  activeViewStorageKey: string | null,
): boolean {
  if (
    state.initializedFromStorage &&
    activeViewStorageKey === state.activeViewStorageKey
  ) {
    return true;
  }

  state.activeViewStorageKey = activeViewStorageKey;
  state.initializedFromStorage = false;
  return false;
}
